import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

// Connects to data-controller="multi-monitor-chart"
// Renders a combo chart with grouped bars (trees per monitor) and lines (avg time per monitor)
export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    data: Object,
    colors: Array
  }

  connect() {
    this.renderChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  renderChart() {
    const ctx = this.canvasTarget.getContext("2d")
    const { monitors, periods, trees, time } = this.dataValue
    const colors = this.colorsValue

    // Create datasets: one bar + one line per monitor
    const datasets = []
    let order = monitors.length * 2

    monitors.forEach((monitor, idx) => {
      const color = colors[idx] || this.generateColor(idx)

      // Bar dataset for trees
      datasets.push({
        type: "bar",
        label: `${monitor}`,
        data: periods.map(p => trees[monitor]?.[p] || 0),
        backgroundColor: color,
        borderColor: color,
        borderWidth: 1,
        yAxisID: "y",
        order: order--,
        stack: undefined,
        barPercentage: 0.8,
        categoryPercentage: 0.85
      })

      // Line dataset for avg time
      datasets.push({
        type: "line",
        label: `${monitor} (min)`,
        data: periods.map(p => time[monitor]?.[p]),
        borderColor: color,
        backgroundColor: "transparent",
        borderWidth: 2,
        pointRadius: 3,
        pointHoverRadius: 5,
        tension: 0.3,
        fill: false,
        yAxisID: "y1",
        order: order--,
        borderDash: [5, 3]
      })
    })

    this.chart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: periods,
        datasets: datasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: "index",
          intersect: false
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: { font: { size: 9 } }
          },
          y: {
            type: "linear",
            position: "left",
            beginAtZero: true,
            title: {
              display: true,
              text: "Árboles Inspeccionados",
              font: { size: 10, weight: "bold" }
            },
            ticks: { font: { size: 9 } },
            grid: { color: "#f0f0f0" }
          },
          y1: {
            type: "linear",
            position: "right",
            beginAtZero: true,
            title: {
              display: true,
              text: "Tiempo Prom. (min)",
              font: { size: 10, weight: "bold" }
            },
            ticks: {
              font: { size: 9 },
              callback: (value) => value + " min"
            },
            grid: { display: false }
          }
        },
        plugins: {
          legend: {
            display: true,
            position: "bottom",
            labels: {
              boxWidth: 10,
              font: { size: 9 },
              filter: (item) => {
                // Only show bar legends (not line legends to avoid duplication)
                return !item.text.includes("(min)")
              }
            }
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const label = context.dataset.label || ""
                const value = context.parsed.y
                if (label.includes("(min)")) {
                  return `Tiempo: ${value != null ? value.toFixed(2) + " min" : "-"}`
                }
                return `${label}: ${value} árboles`
              }
            }
          }
        }
      }
    })
  }

  generateColor(index) {
    const hue = (index * 137) % 360
    return `hsl(${hue}, 70%, 50%)`
  }
}

